import { Space, PricingType, DayUnitQuoteItemPrice } from "@/data";
import { parseDay } from "@/lib/datetime";
import { Quote } from "@/offering/api";
import { isSameDay } from "date-fns";
import { getBookingHourFromBookingDate } from "./get_booking_hour_from_booking_date";
import { getHoursFromOpenCloseValues } from "./get_hours_from_open_close_values";

export function calculateSavingAmount(
  quote: Quote,
  space: Space
): number | undefined {
  const quoteItem = quote.quoteItems[0];
  const isHourlyBooking = !!(quoteItem.startTime && quoteItem.endTime);
  const isSingleDateBooking = isSameDay(
    parseDay(quoteItem.startDate),
    parseDay(quoteItem.endDate)
  );
  const baseHourlyPrice = space.pricings.find(
    (p) => p.type === PricingType.Hourly
  )?.price;
  const baseDailyPrice = space.pricings.find(
    (p) => p.type === PricingType.Daily
  )?.price;

  if (isHourlyBooking) {
    if (quoteItem.dynamicPriceRate) {
      const quoteUnitPrice = quoteItem.unitPrice;
      if (baseHourlyPrice && quoteUnitPrice < baseHourlyPrice) {
        return (baseHourlyPrice - quoteUnitPrice) * quoteItem.unitCount;
      }
    }
  } else if (isSingleDateBooking) {
    if (quoteItem.dynamicPriceRate) {
      const quoteUnitPrice = quoteItem.unitPrice;
      if (baseDailyPrice && quoteUnitPrice < baseDailyPrice) {
        return baseDailyPrice - quoteUnitPrice;
      }
    } else {
      const bookingHour = getBookingHourFromBookingDate(
        space.bookingHours,
        quoteItem.startDate
      );
      const numberOfOpeningHours = getHoursFromOpenCloseValues(
        bookingHour?.openAt,
        bookingHour?.closedAt
      );
      const hourlyPrice = baseHourlyPrice
        ? baseHourlyPrice * numberOfOpeningHours
        : undefined;
      const quoteUnitPrice = quoteItem.unitPrice;
      if (hourlyPrice && quoteUnitPrice < hourlyPrice) {
        return hourlyPrice - quoteUnitPrice;
      }
    }
  } else if (quoteItem.quoteItemPrices.length) {
    const originalPrice = quoteItem.quoteItemPrices.reduce(
      (prev, cur) => prev + cur.originalUnitPrice,
      0
    );
    const totalQuoteItemPrices = quoteItem.quoteItemPrices.reduce(
      (prev, cur) => prev + cur.unitPrice,
      0
    );
    if (originalPrice > totalQuoteItemPrices) {
      return originalPrice - totalQuoteItemPrices;
    } else {
      const quoteItemPrices: DayUnitQuoteItemPrice[] = [];
      quoteItem.quoteItemPrices.forEach((item) => {
        if (item.unitType === "day_unit") {
          quoteItemPrices.push(item);
        }
      });
      const bookingDates = quoteItemPrices.map((price) => price.startDate);
      let numberOfOpeningHours = 0;
      bookingDates.forEach((bookingDate) => {
        const bookingHour = getBookingHourFromBookingDate(
          space.bookingHours,
          bookingDate
        );
        numberOfOpeningHours += getHoursFromOpenCloseValues(
          bookingHour?.openAt,
          bookingHour?.closedAt
        );
      });
      const totalHourlyPrice = baseHourlyPrice
        ? baseHourlyPrice * numberOfOpeningHours
        : undefined;

      if (totalHourlyPrice && totalHourlyPrice > quoteItem.subTotal) {
        return totalHourlyPrice - quoteItem.subTotal;
      }
    }
  }
}
